import { createSelector } from "reselect"
import { get, last, chain } from "lodash"
import { computeFactorSensitivityContributors } from "./helper"

const EMPTY_OBJECT = {}
const EMPTY_ARRAY = []

const getHistoricalFactorSensitivityErrors = state => get(state, "global.data.historicalFactorSensitivity.apiMessages.errors")
export const getHistoricalFactorSensitivitySummary = state => get(state, "global.data.historicalFactorSensitivity.data.model.simulation.historicalFactorSensitivity.0", EMPTY_OBJECT)
export const getRebalancedHistoricalFactorSensitivitySummary = state => get(state, "modules.rebalance.rebalancedHistoricalFactorSensitivity.0", EMPTY_ARRAY)

// Contributors
const getRawHistoricalFactorSensitivityContributors = state => get(state, "global.data.historicalFactorSensitivityContributors.data.model.simulation.historicalFactorSensitivityContributors", EMPTY_ARRAY)
const getRawRebalancedHistoricalFactorSensitivityContributors = state => get(state, "modules.rebalance.rebalancedHistoricalFactorSensitivityContributors", EMPTY_ARRAY)

// Grouped Contributors
const getRawGroupedHistoricalFactorSensitivityContributors = state => get(state, "global.data.groupedHistoricalFactorSensitivityContributors.data.model.simulation.groupedHistoricalFactorSensitivityContributors", EMPTY_ARRAY)
const getRawGroupedRebalancedHistoricalFactorSensitivityContributors = state => get(state, "modules.rebalance.rebalancedGroupedHistoricalFactorSensitivityContributors", EMPTY_ARRAY)

export const getHistoricalFactorSensitivityUnavailable = createSelector(
  [getHistoricalFactorSensitivityErrors],
  (errors) => chain(errors)
    .find(({ path }) => last(path) === "historicalFactorSensitivity")
    .get("message")
    .value(),
)

export const getHistoricalFactorSensitivityContributors = createSelector(
  [getRawHistoricalFactorSensitivityContributors],
  computeFactorSensitivityContributors,
)

export const getGroupedHistoricalFactorSensitivityContributors = createSelector(
  [getRawGroupedHistoricalFactorSensitivityContributors],
  computeFactorSensitivityContributors,
)

export const getRebalancedHistoricalFactorSensitivityContributors = createSelector(
  [getRawRebalancedHistoricalFactorSensitivityContributors],
  computeFactorSensitivityContributors,
)

export const getGroupedRebalancedHistoricalFactorSensitivityContributors = createSelector(
  [getRawGroupedRebalancedHistoricalFactorSensitivityContributors],
  computeFactorSensitivityContributors,
)
